if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.isInitialized = false;
        this.init();
      }

      connectedCallback() {
        if (this.isInitialized) return;
        this.init();
      }

      init() {
        if (this.isInitialized) return;

        this.form = this.querySelector("form");
        if (!this.form) return;

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        this.isInitialized = true;

        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButtonText = this.submitButton.querySelector("span") || this.submitButton;

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      showPLPError(errorResponse) {
        if (!errorResponse || !errorResponse.productVariantId) return;
        const variantId = errorResponse.productVariantId;
        const message = errorResponse.message || errorResponse.errors;
        // Find the matching product card error container
        const errorEl = document.querySelector(
          `.showplperror[product-variant-id="${variantId}"]`
        );

        if (errorEl) {
          errorEl.textContent = message;
          errorEl.style.display = 'flex';
          errorEl.classList.add('active');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        document.querySelectorAll(".product-form-error-message-wrapper").forEach((error) => {
          error.setAttribute("hidden", "hidden");
          error.querySelector(".product-form-error-message").textContent = "";
        });

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // The quantity input can live outside this <form> and only associate through its
        // `form` attribute, which does not reliably populate FormData. Read it explicitly,
        // scoped to this form (falling back to this product-info) so quick-add modals and
        // other product forms on the page each submit their own quantity.
        const quantityInput =
          (this.form.id &&
            document.querySelector(`input[name="quantity"][form="${this.form.id}"]`)) ||
          (this.closest("product-info") || document).querySelector('input[name="quantity"]');
        if (quantityInput && quantityInput.value) {
          formData.set("quantity", quantityInput.value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
    

            
            if (response.status) {
              this.showPLPError({
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              })

              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              if (response.description) {
                document.querySelectorAll(".product-form-error-message-wrapper").forEach((error) => {
                  error.removeAttribute("hidden");
                  error.querySelector(".product-form-error-message").textContent = response.description;
                });

                const qtyWrapper = document.querySelector(".product-qty-buttons-wrapper");
                const qtyPlus = qtyWrapper?.querySelector(".quantity-plus");
                if (qtyPlus) qtyPlus.disabled = true;
              }

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (window.Pandectes && window.Pandectes.consent.performance === true) {
              const selectedVariant = document
                .querySelector(".product-details-wrapper")
                .querySelector("variant-selects [data-selected-variant]")?.innerHTML;

              const parsedSelectedVariant = JSON.parse(selectedVariant);

              const addtoCartData = {
                Name: productInfo?.title,
                ProductID: parsedSelectedVariant?.sku, //sku
                ImageURL: productInfo?.images[0],
                URL: window.location.href,
                Brand: productInfo?.vendor,
                Price: (parsedSelectedVariant?.price / 100).toString(), //Price
                CompareAtPrice: (parsedSelectedVariant?.compare_at_price / 100).toString(), //if available
              };

              klaviyo.track("Added to Cart", addtoCartData);
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            //alert('dd');
            console.log(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          if (this.submitButton) this.submitButton.setAttribute("disabled", "disabled");
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          if (this.submitButton) this.submitButton.removeAttribute("disabled");
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
